var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"canvas",class:{
    open: _vm.Open,
  },staticStyle:{"object-fit":"cover"},attrs:{"src":require('@/assets/Images/Colecciones/QUITO/QUITO&FONDO.webp'),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }